import { Notification } from "@app/shared";
import { ExportQueuedModel, ExportReadyModel, ExportStartedModel } from "@app/macd-common";
import { ToastLevel } from "@app/components";
@Notification({
  name: "ServicesMatrixExportReadyNotification",
})
export class ServicesMatrixExportReadyNotification{
    public url: string;
    public mode: number;

    public getMessage(){
       return { message: new ExportReadyModel(this.url, this.mode), id: this['id'], createdDate: this['createdDate'], isDismissable: this['isDismissable'], sender: this['sender'], level: ToastLevel.Information };
    }
}

@Notification({
  name: "ServicesMatrixExportStartedNotification",
})

export class ServicesMatrixExportStartedNotification{
  public getMessage(){
       return { message: new ExportStartedModel(), id: this['id'], createdDate: this['createdDate'], isDismissable: this['isDismissable'], sender: this['sender'], level: ToastLevel.Information };
    }
}

@Notification({
  name: "ServicesMatrixExportQueuedNotification",
})

export class ServicesMatrixExportQueuedNotification{
   public getMessage(){
       return { message: new ExportQueuedModel(), id: this['id'], createdDate: this['createdDate'], isDismissable: this['isDismissable'], sender: this['sender'], level: ToastLevel.Information };
    }
}